import React from 'react';
import {connect} from "react-redux"

import Tabs from "react-toolbox/lib/tabs/Tabs";
import Tab from "react-toolbox/lib/tabs/Tab";

import AuthRequiredComponent from "../components/common/AuthRequiredComponent";
import Header from "../components/common/Header";
import l10n from "../l10n/localization";

import NotificationsSystem from 'reapop';
import reapopTheme from 'reapop-theme-wybo';
import CWDrawer from "../components/drawer/CWDrawer";
import FogTableWrapper from "../components/fog/FogTableWrapper";
import ClientTableWrapper from "../components/client/ClientTableWrapper";
import Preferences from "./Preferences";
import * as authHandler from "../utils/authHandler";
import * as routes from "../constants/routes";
import { history } from '../constants/common';

class Home extends AuthRequiredComponent {
	/**
	 * @param props
	 */
    constructor(props) {
        super(props);

        this.state = {
            form: null,
            item: null,
            active: false,
            index: 0,
            destroyer: null,
        };
    }

	/**
	 * @param {int} index
	 */
	handleTabChange = (index) => {
        this.setState({index});
    };

    handleClick(component, item, destroyer) {

        this.setState({active: false}, () => {
            this.setState({form: component, item: item, active: true, destroyer: destroyer})
        })
    }

    closeDrawer() {
        this.setState({active: false}, function() {
            this.props.dispatch(this.state.destroyer);
        })
    }

    render() {
        if (!authHandler.isLoggedIn()) {
            history.push(routes.LOGIN);
        }

        return (
            <div>
                <div id="notification-center">
                    <NotificationsSystem theme={reapopTheme} />
                </div>
                <Header {...this.props} />
                <Tabs className="main-tab" index={this.state.index} inverse onChange={this.handleTabChange}>
                    <Tab label={l10n.common.menuFogFiles}>
                        <div className="main-content">
                            <FogTableWrapper handleClick={(Component, item, destroyer) => this.handleClick(Component, item, destroyer)} />
                        </div>
                    </Tab>
                    <Tab label={l10n.common.menuClients}>
                        <div className="main-content">
                            <ClientTableWrapper handleClick={(Component, item, destroyer) => this.handleClick(Component, item, destroyer)} />
                        </div>
                    </Tab>
                    <Tab label={l10n.common.menuPreferences}>
                        <div className="main-content">
                            <Preferences handleClick={(Component, item, destroyer) => this.handleClick(Component, item, destroyer)} />
                        </div>
                    </Tab>
                </Tabs>

                {<CWDrawer {...this.props} outlet={this.state.form}
                              active={this.state.active}
                              depth={0}
                              item={this.state.item}
                              closeDrawer={() => this.closeDrawer()} />}
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        user: state.user,
        edit: state.edit
    });
})(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js